/* Argentinísimo · "Armá tu combo" (snippets/arg-combo.liquid + sections/arg-combo-data.liquid)
   - Paso 1: el cliente elige la promo (3x2, 5x3, 7x4, 10x5). Paso 2: ve las camisetas que entran
     y cuántas le faltan. Los botones de la página de producto abren directo en el paso 2.
   - Cada camiseta lleva su talle y, si quiere, nombre y número (variante "Personalizar").
   - Cuenta lo que ya hay en el carrito. Al final agrega todo junto y muestra el
     descuento que aplicó Shopify de verdad (no lo calcula el tema). */
(function () {
  if (window.__argCombo) return;
  window.__argCombo = true;

  var root = document.querySelector('[data-arg-combo]');
  if (!root) return;
  var RE_PERS = /^personalizar$/i;
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var maxChars = +root.dataset.maxChars || 12, maxNum = +root.dataset.maxNumber || 99;
  var actual = JSON.parse(root.querySelector('[data-combo-actual]').textContent);
  var S = { meta: 3, items: [], carrito: 0, col: null, cache: {}, ultimo: null, key: 0 };
  var PROMO = { 3: 'Llevá 3, pagá 2', 5: 'Llevá 5, pagá 3', 7: 'Llevá 7, pagá 4', 10: 'Llevá 10, pagá 5' };
  var CORTO = { 3: '“Llevá 3, pagá 2”', 5: '“Llevá 5, pagá 3”', 7: '“Llevá 7, pagá 4”', 10: '“Llevá 10, pagá 5”' };

  function $(s, r) { return (r || root).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function dinero(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format(c / 100); }
    catch (e) { return '$' + (c / 100).toFixed(2); }
  }
  function plural(n, a, b) { return n === 1 ? a : b; }

  /* ---------- variantes ---------- */
  function opcionesTalle(p) { return p.o.map(function (n, i) { return i; }).filter(function (i) { return i !== p.pz; }); }
  function variante(p, sel, pers) {
    var idx = opcionesTalle(p);
    return p.v.filter(function (v) {
      if (p.pz >= 0 && RE_PERS.test(String(v[1][p.pz]).trim()) !== pers) return false;
      return idx.every(function (i, k) { return v[1][i] === sel[k]; });
    })[0] || null;
  }
  function valores(p, i) {
    var out = [];
    p.v.forEach(function (v) { if (out.indexOf(v[1][i]) < 0) out.push(v[1][i]); });
    return out;
  }
  function hayStock(p, i, val) {
    return p.v.some(function (v) { return v[2] && v[1][i] === val && (p.pz < 0 || !RE_PERS.test(String(v[1][p.pz]).trim())); });
  }

  /* ---------- estado del combo ---------- */
  function faltan() {
    var g = S.meta, tot = S.carrito + S.items.length, r = tot % g;
    return { tot: tot, falta: tot === 0 ? g : (r === 0 ? 0 : g - r), llenos: tot > 0 && r === 0 ? g : r };
  }
  function pintarEstado() {
    var g = S.meta, f = faltan(), nombre = CORTO[g];
    $$('[data-combo-meta]').forEach(function (b) {
      var on = +b.dataset.comboMeta === g; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var txt;
    if (f.falta === 0) {
      txt = '¡Listo! Completaste el ' + nombre + ' con ' + f.tot + ' camisetas' + (S.carrito ? ' (contando ' + S.carrito + ' del carrito)' : '') + '.';
    } else {
      txt = PROMO[g] + ': te ' + plural(f.falta, 'falta ', 'faltan ') + f.falta + ' ' + plural(f.falta, 'camiseta', 'camisetas') + '.';
      if (S.carrito) txt += ' Ya contamos ' + S.carrito + ' de tu carrito.';
    }
    if (g === 10) {
      var fuera = S.items.filter(function (it) { return !it.p.e10; }).length;
      if (fuera) txt += ' ' + fuera + ' de las elegidas no entra' + (fuera > 1 ? 'n' : '') + ' en “Llevá 10, pagá 5”.';
    }
    $('[data-combo-msg]').textContent = txt;
    $('[data-combo-msg]').classList.toggle('is-ok', f.falta === 0);
    var delCarrito = Math.max(0, f.llenos - S.items.length), html = '';
    for (var i = 0; i < g; i++) html += '<i class="' + (i < delCarrito ? 'is-cart' : (i < f.llenos ? 'is-on' : '')) + '"></i>';
    $('[data-combo-slots]').innerHTML = html;

    $('[data-combo-lista]').innerHTML = S.items.length ? '<p class="arg-combo__h">Tu combo</p>' + S.items.map(function (it) {
      return '<div class="arg-combo__item"><img src="' + esc(it.p.img) + '" alt="" width="52" height="52" loading="lazy">' +
        '<div><p class="arg-combo__it-t">' + esc(it.p.t) + '</p><p class="arg-combo__it-m">' + esc(it.etiqueta) + (it.nombre ? ' · ' + esc(it.nombre) + ' #' + esc(it.numero) : '') + '</p></div>' +
        '<button type="button" class="arg-combo__quitar" data-combo-quitar="' + it.key + '" aria-label="Quitar ' + esc(it.p.t) + '">×</button></div>';
    }).join('') : '';
    var add = $('[data-combo-add]');
    add.disabled = !S.items.length;
    add.textContent = S.items.length ? 'Agregar ' + S.items.length + ' ' + plural(S.items.length, 'camiseta', 'camisetas') + ' al carrito' : 'Elegí al menos una camiseta';
  }

  /* ---------- editor de una camiseta ---------- */
  function editar(p, pre) {
    pre = pre || {};
    if (p === actual && !pre.sel) {
      var pz = document.querySelector('[data-arg-pz]');
      var f = (pz && document.getElementById(pz.dataset.form)) || document.querySelector('product-info form[action*="/cart/add"]');
      var idIn = f && f.querySelector('[name="id"]');
      var v = idIn && actual.v.filter(function (x) { return String(x[0]) === idIn.value; })[0];
      if (v) pre.sel = opcionesTalle(actual).map(function (i) { return v[1][i]; });
    }
    var ed = $('[data-combo-editor]'), idx = opcionesTalle(p);
    var html = '<div class="arg-combo__ed-top"><img src="' + esc(p.img) + '" alt="" width="64" height="64"><p>' + esc(p.t) + '</p></div>';
    idx.forEach(function (i, k) {
      html += '<p class="arg-combo__lbl">' + esc(p.o[i]) + '</p><div class="arg-combo__tallas" data-ed-opt="' + k + '">' +
        valores(p, i).map(function (val) {
          var ok = hayStock(p, i, val), sel = pre.sel && pre.sel[k] === val && ok;
          return '<button type="button" data-val="' + esc(val) + '"' + (ok ? '' : ' disabled') + (sel ? ' class="is-on"' : '') + '>' + esc(val) + '</button>';
        }).join('') + '</div>';
    });
    if (p.pz >= 0) {
      html += '<label class="arg-combo__pers"><input type="checkbox" data-ed-pers' + (pre.nombre ? ' checked' : '') + '> Personalizar gratis (nombre y número)</label>' +
        '<div class="arg-combo__pfields" data-ed-pfields' + (pre.nombre ? '' : ' hidden') + '>' +
        '<label><span>Nombre</span><input type="text" data-ed-nombre maxlength="' + maxChars + '" autocapitalize="characters" autocomplete="off" placeholder="TU NOMBRE" value="' + esc(pre.nombre || '') + '"></label>' +
        '<label><span>Número</span><input type="text" data-ed-numero inputmode="numeric" maxlength="2" autocomplete="off" placeholder="10" value="' + esc(pre.numero || '') + '"></label></div>';
    }
    html += '<p class="arg-combo__err" data-ed-err aria-live="polite"></p>' +
      '<div class="arg-combo__ed-btns"><button type="button" class="arg-combo__ok" data-ed-ok>Sumar al combo</button><button type="button" class="arg-combo__cancel" data-ed-cancel>Cancelar</button></div>';
    ed.innerHTML = html;
    ed._p = p;
    ed.hidden = false;
    $('[data-combo-picker]').hidden = true;
    ed.scrollIntoView({ block: 'nearest' });
  }
  function cerrarEditor() {
    var ed = $('[data-combo-editor]'); ed.hidden = true; ed.innerHTML = ''; ed._p = null;
    $('[data-combo-picker]').hidden = false;
  }
  function confirmar() {
    var ed = $('[data-combo-editor]'), p = ed._p, err = $('[data-ed-err]', ed);
    var sel = $$('[data-ed-opt]', ed).map(function (g) { var b = $('.is-on', g); return b ? b.dataset.val : null; });
    if (sel.some(function (x) { return x == null; })) { err.textContent = 'Elegí el talle.'; return; }
    var pers = !!($('[data-ed-pers]', ed) && $('[data-ed-pers]', ed).checked), nombre = '', numero = '';
    if (pers) {
      nombre = $('[data-ed-nombre]', ed).value.trim().toUpperCase();
      numero = $('[data-ed-numero]', ed).value.trim();
      if (!nombre) { err.textContent = 'Escribí el nombre o destildá “Personalizar”.'; return; }
      if (!numero) { err.textContent = 'Escribí el número o destildá “Personalizar”.'; return; }
      if (+numero > maxNum) { err.textContent = 'El número tiene que ser del 0 al ' + maxNum + '.'; return; }
    }
    var v = variante(p, sel, pers);
    if (!v || !v[2]) { err.textContent = 'Ese talle no está disponible.'; return; }
    S.items.push({ key: ++S.key, p: p, vid: v[0], etiqueta: sel.join(' / '), nombre: nombre, numero: numero });
    cerrarEditor();
    pintarEstado();
  }

  /* ---------- catálogo por colección (solo productos de la promo) ---------- */
  function cargar(col) {
    S.col = col;
    $$('[data-combo-col]').forEach(function (b) { var on = b.dataset.comboCol === col; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    var grid = $('[data-combo-grid]');
    if (S.cache[col]) return mostrar(S.cache[col]);
    grid.innerHTML = '<p class="arg-combo__cargando">Cargando camisetas…</p>';
    fetch(R + 'collections/' + encodeURIComponent(col) + '?section_id=arg-combo-data')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var d = JSON.parse(doc.querySelector('[data-arg-combo-data]').textContent);
        S.cache[col] = d.products;
        if (S.col === col) mostrar(d.products);
      })
      .catch(function () { grid.innerHTML = '<p class="arg-combo__cargando">No pudimos cargar las camisetas. Probá de nuevo.</p>'; });
  }
  function mostrar(ps) {
    var grid = $('[data-combo-grid]');
    ps = (ps || []).filter(function (p) { return p.h !== actual.h; });
    if (S.meta !== 10 || actual.e10) ps = [actual].concat(ps);
    if (S.meta === 10) ps = ps.filter(function (p) { return p.e10; });
    if (!ps.length) { grid.innerHTML = '<p class="arg-combo__cargando">No hay camisetas disponibles en esta selección.</p>'; return; }
    grid.innerHTML = ps.map(function (p, i) {
      var precio = Math.min.apply(null, p.v.filter(function (v) { return v[2]; }).map(function (v) { return v[3]; }));
      return '<button type="button" class="arg-combo__card" data-combo-elegir="' + i + '">' +
        '<span class="arg-combo__img">' + (p === actual ? '<b class="arg-combo__esta">Esta camiseta</b>' : '') + '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="150" height="150"></span>' +
        '<span class="arg-combo__ct">' + esc(p.t) + '</span><span class="arg-combo__cp">' + dinero(precio) + '</span>' +
        '<span class="arg-combo__cb">+ Elegir</span></button>';
    }).join('');
    grid._ps = ps;
  }

  /* ---------- abrir / cerrar ---------- */
  var ultimoFoco = null;
  function paso(n) {
    $('[data-combo-paso1]').hidden = n !== 1;
    $('[data-combo-paso2]').hidden = n !== 2;
    $('.arg-combo__back').hidden = n !== 2;
    $('.arg-combo__title').textContent = n === 2 ? PROMO[S.meta] : 'Armá tu combo';
    if (n === 2) {
      pintarEstado();
      if (!S.col) { var c1 = $('[data-combo-col]'); cargar(c1 ? c1.dataset.comboCol : 'all'); }
      else if (S.cache[S.col]) mostrar(S.cache[S.col]);
    }
  }
  function abrir(meta) {
    meta = PROMO[meta] ? meta : 0;
    ultimoFoco = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('arg-combo-open');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    if (meta) { S.meta = meta; paso(2); } else paso(1);
    fetch(R + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { S.carrito = c.item_count || 0; pintarEstado(); }).catch(function () {});
    setTimeout(function () { var x = $('.arg-combo__x'); if (x) x.focus({ preventScroll: true }); }, 50);
  }
  function cerrar() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('arg-combo-open');
    setTimeout(function () { root.hidden = true; }, 220);
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus({ preventScroll: true });
  }

  /* ---------- agregar todo al carrito ---------- */
  function agregar() {
    var btn = $('[data-combo-add]');
    if (!S.items.length) return;
    btn.disabled = true; btn.textContent = 'Agregando…';
    var drawer = document.querySelector('cart-drawer');
    var items = S.items.map(function (it) {
      var o = { id: it.vid, quantity: 1 };
      if (it.nombre) o.properties = { 'Nome': it.nombre, 'Número': it.numero, 'Personalización': 'Nombre propio' };
      return o;
    });
    fetch(R + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'No se pudo agregar.');
        S.ultimo = res;
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && res.sections && res.sections['cart-icon-bubble']) {
          var d = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
          var nb = d.querySelector('.shopify-section') || d.body; bubble.innerHTML = nb.innerHTML;
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'arg-combo' });
        return fetch(R + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var n = S.items.length;
        S.items = []; S.carrito = cart.item_count;
        var titulos = {};
        (cart.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { if (a.amount > 0 && a.discount_application) titulos[a.discount_application.title] = 1; }); });
        (cart.cart_level_discount_applications || []).forEach(function (a) { titulos[a.title] = 1; });
        var lista = Object.keys(titulos), f = faltan();
        var html = '<div class="arg-combo__res"><p class="arg-combo__res-t">¡Listo! Agregaste ' + n + ' ' + plural(n, 'camiseta', 'camisetas') + '.</p>';
        if (cart.total_discount > 0) html += '<p class="arg-combo__res-ok">Shopify ya aplicó <strong>' + esc(lista.join(' + ') || 'la promo') + '</strong>: ahorrás <strong>' + dinero(cart.total_discount) + '</strong> en tu carrito.</p>';
        else html += '<p>Todavía no se aplica la promo: con ' + f.falta + ' ' + plural(f.falta, 'camiseta', 'camisetas') + ' más completás el ' + CORTO[S.meta] + '.</p>';
        html += '<div class="arg-combo__res-btns"><button type="button" class="arg-combo__ok" data-combo-ver>Ver carrito</button><button type="button" class="arg-combo__cancel" data-combo-seguir>Seguir armando</button></div></div>';
        $('[data-combo-lista]').innerHTML = html;
        $('[data-combo-editor]').hidden = true;
        $('.arg-combo__body').scrollTop = 0;
        pintarEstadoSinLista();
      })
      .catch(function (e) {
        btn.disabled = false; btn.textContent = 'Agregar al carrito';
        $('[data-combo-msg]').textContent = 'No se pudo agregar: ' + e.message;
      });
  }
  function pintarEstadoSinLista() {
    var lista = $('[data-combo-lista]').innerHTML;
    pintarEstado();
    $('[data-combo-lista]').innerHTML = lista;
  }
  function verCarrito() {
    var drawer = document.querySelector('cart-drawer'), res = S.ultimo;
    cerrar();
    if (!drawer || !res) { window.location.href = R + 'cart'; return; }
    try { drawer.renderContents({ id: res.items && res.items[0] && res.items[0].variant_id, sections: res.sections }); }
    catch (e) { window.location.href = R + 'cart'; return; }
    drawer.classList.remove('is-empty');
  }

  /* ---------- eventos ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-arg-combo-open]');
    if (o) { e.preventDefault(); abrir(+o.dataset.argComboOpen); }
  });
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, [data-combo-close]');
    if (!t) return;
    if (t.hasAttribute('data-combo-close')) return cerrar();
    if (t.dataset.comboElegirMeta) { S.meta = +t.dataset.comboElegirMeta; return paso(2); }
    if (t.dataset.comboPaso) return paso(1);
    if (t.dataset.comboMeta) { S.meta = +t.dataset.comboMeta; $('.arg-combo__title').textContent = PROMO[S.meta]; pintarEstado(); if (S.cache[S.col]) mostrar(S.cache[S.col]); return; }
    if (t.dataset.comboCol) return cargar(t.dataset.comboCol);
    if (t.dataset.comboElegir != null) { var g = $('[data-combo-grid]'); return editar(g._ps[+t.dataset.comboElegir]); }
    if (t.dataset.comboQuitar) { S.items = S.items.filter(function (it) { return String(it.key) !== t.dataset.comboQuitar; }); return pintarEstado(); }
    if (t.hasAttribute('data-ed-ok')) return confirmar();
    if (t.hasAttribute('data-ed-cancel')) return cerrarEditor();
    if (t.hasAttribute('data-combo-add')) return agregar();
    if (t.hasAttribute('data-combo-ver')) return verCarrito();
    if (t.hasAttribute('data-combo-seguir')) { pintarEstado(); return; }
    var grupo = t.closest('[data-ed-opt]');
    if (grupo && !t.disabled) { $$('button', grupo).forEach(function (b) { b.classList.toggle('is-on', b === t); }); $('[data-ed-err]').textContent = ''; }
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-ed-pers]')) $('[data-ed-pfields]').hidden = !e.target.checked;
  });
  root.addEventListener('input', function (e) {
    if (e.target.matches('[data-ed-nombre]')) e.target.value = e.target.value.toUpperCase().replace(/[^A-ZÁÉÍÓÚÜÑ .'\-]/g, '').replace(/^\s+/, '').slice(0, maxChars);
    if (e.target.matches('[data-ed-numero]')) e.target.value = e.target.value.replace(/\D/g, '').slice(0, 2);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) cerrar(); });
})();
